//#region Imports
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import { Box, Grid, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//components
// import StatusBar from '../../../components/statusbar/statusbar';
import ProcessingSummaryTable from '../../../components/processingSummaryTable/processingSummaryTable';
import {
  convertDate,
  convertDateDDMMYY,
  convertDatewithTime,
  downloadBill,
  numberFormatting,
  sodowo,
  subdivisionName
} from "../../../services/Functions";
//scss
import "../../../style/common.scss";
//Yup
//formik
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
// authorization
import CheckPermissions from '../../../authorization/authorization';
// Services
//jspdf
import 'jspdf-autotable';
//jsbarcode
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import warning from '../../../images/warning.png';
import { tableStyle, tableStyleOverDue } from '../../../style/common';
//pdfjs
import { useDispatch, useSelector } from 'react-redux';
import ActionsCell from '../../../components/actionCell/ActionCell';
import BasicTable from '../../../components/basicTable/basicTable';
import Error from '../../../components/error/error';
import {
  fetchPaginatedBillCorrectionNormal,
  filterDateFrom as filterDateFromNormal,
  filterDateTo as filterDateToNormal,
  filterObjectionStatus as filterObjectionStatusNormal,
  filterProgressId as filterProgressIdNormal,
  firstPage as firstPageNormal,
  lastPage as lastPageNormal,
  nextPage as nextPageNormal,
  previousPage as prePageNormal,
  resetDateFilter as resetDateFilterNormal,
  resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
  resetProgressIdFilter as resetProgressIdFilterNormal
} from '../../../features/generalServices/bcNormalSlice';
import {
  fetchPaginatedBillCorrectionOverdue,
  filterDateFrom as filterDateFromOverdue,
  filterDateTo as filterDateToOverdue,
  filterObjectionStatus as filterObjectionStatusOverdue,
  filterProgressId as filterProgressIdOverdue,
  firstPage as firstPageOverdue,
  lastPage as lastPageOverdue,
  nextPage as nextPageOverdue,
  previousPage as prePageOverdue,
  resetDateFilter as resetDateFilterOverdue,
  resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
  resetProgressIdFilter as resetProgressIdFilterOverdue
} from '../../../features/generalServices/bcOverdueSlice';
import { SearchIndividualApplication } from '../../../network/APIs/APIs';
//#endregion

const BillCorrectionTable = forwardRef((props, ref) => {

  //#region paginatedlogic
  const dispatch = useDispatch();
  const { currentPage: currentPageNormal, data: dataNormal, pageSize: pageSizeNormal, totalPages: totalPagesNormal, totalRecords: totalRecordsNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, loadFrom: loadFromNormal, loadTo: loadToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, error: rcNormalError } = useSelector((state) => state.bcNormalPaginated);
  const { currentPage: currentPageOverdue, data: dataOverdue, pageSize: pageSizeOverdue, totalPages: totalPagesOverdue, totalRecords: totalRecordsOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, loadFrom: loadFromOverdue, loadTo: loadToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, error: rcOverdueError } = useSelector((state) => state.bcOverduePaginated);
  const { token, userId, hierarchy, roleId, roleName, permissions } = useSelector((state) => state.auth)

  // useEffect(() => {
  //   if ((rcNormalError && rcNormalError === "Failed to fetch") || (rcOverdueError && rcOverdueError === "Failed to fetch")) {
  //     alert("Network issue! NCAPIE")
  //     dispatch(resetStateRcNormal());
  //     dispatch(resetStateRcOverdue());
  //     dispatch(resetStateConNormal());
  //     dispatch(resetStateConOverdue());
  //     dispatch(resetStateColNormal());
  //     dispatch(resetStateColOverdue());
  //     dispatch(resetStateCotNormal());
  //     dispatch(resetStateCotOverdue());
  //     dispatch(resetStateDueDate());
  //     dispatch(resetStateInstallmentsNormal())
  //     dispatch(resetStateInstallmentsOverdue())
  //     dispatch(removeStats());
  //     dispatch(resetOverallPerformanceState());
  //     dispatch(resetFeederStatusState());
  //     dispatch(resetGeoJsonState());
  //     dispatch(signOut())
  //   }
  // }, [rcNormalError, rcOverdueError])

  const handleNextPageNormal = () => {
    setViewBackdrop(true)
    dispatch(nextPageNormal());
  };

  const handleDateFromFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterDateFromNormal(value))
    }
  }

  const handleDateToFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterDateToNormal(value))
    }
  }

  const handleResetDateFilterNormal = () => {
    dispatch(resetDateFilterNormal())
  }

  const handleProgressIdFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true)
      dispatch(filterProgressIdNormal(value))
    }
  }

  const handleResetProgressIdFilterNormal = () => {
    dispatch(resetProgressIdFilterNormal())
  }

  const handleObjectionStatusFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true)
      dispatch(filterObjectionStatusNormal(value))
    }
  }

  const handleResetObjectionStatusFilterNormal = () => {
    dispatch(resetObjectionStatusFilterNormal())
  }

  const handlePreviousPageNormal = () => {
    setViewBackdrop(true)
    dispatch(prePageNormal());
  };

  const handleFirstPageNormal = () => {
    dispatch(firstPageNormal());
  };

  const handleLastPageNormal = () => {
    dispatch(lastPageNormal(totalPagesNormal)); // Replace '2' with actual value
  };

  useEffect(() => {
    if (token) {
      setViewBackdrop(true)
      dispatch(fetchPaginatedBillCorrectionNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, loadFrom: loadFromNormal, loadTo: loadToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
    }
  }, [currentPageNormal, pageSizeNormal, dateFromNormal, dateToNormal, loadFromNormal, loadToNormal, applicationProgressIdNormal, objectionStatusNormal]);

  useEffect(() => {
    setViewBackdrop(true)
    dispatch(fetchPaginatedBillCorrectionNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, loadFrom: loadFromNormal, loadTo: loadToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
  }, []);

  useEffect(() => {
    if (dataNormal) {
      setBillCorrectionApplications(dataNormal)
      setViewBackdrop(false)
    }
  }, [dataNormal])

  const handleNextPageOverdue = () => {
    setViewBackdrop(true)
    dispatch(nextPageOverdue());
  };

  const handleDateFromFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterDateFromOverdue(value))
    }
  }

  const handleDateToFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterDateToOverdue(value))
    }
  }
  const handleResetDateFilterOverdue = () => {
    dispatch(resetDateFilterOverdue())
  }
  const handleProgressIdFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterProgressIdOverdue(value))
    }
  }

  const handleResetProgressIdFilterOverdue = () => {
    dispatch(resetProgressIdFilterOverdue())
  }

  const handleObjectionStatusFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterObjectionStatusOverdue(value))
    }
  }

  const handleResetObjectionStatusFilterOverdue = () => {
    dispatch(resetObjectionStatusFilterOverdue())
  }

  const handlePreviousPageOverdue = () => {
    setViewBackdrop(true)
    dispatch(prePageOverdue());
  };

  const handleFirstPageOverdue = () => {
    dispatch(firstPageOverdue());
  };

  const handleLastPageOverdue = () => {
    dispatch(lastPageOverdue(totalPagesOverdue)); // Replace '2' with actual value
  };

  useEffect(() => {
    dispatch(fetchPaginatedBillCorrectionOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, loadFrom: loadFromOverdue, loadTo: loadToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
  }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, loadFromOverdue, loadToOverdue, applicationProgressIdOverdue, objectionStatusOverdue]);

  useEffect(() => {
    if (dataOverdue) {
      setBillCorrectionApplicationsOverDue(dataOverdue)
      setViewBackdrop(false)
    }
  }, [dataOverdue])

  //#endregion

  //#region initial values
  const initialValues = {

  }

  //#endregion

  //#region get item local storage 
  const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
  //#endregion

  //#region states 
  const [allTariffList, setAllTariffList] = useState();
  const [viewBackdrop, setViewBackdrop] = useState(false);

  const [billCorrectionApplications, setBillCorrectionApplications] = useState([]);

  const [billCorrectionApplicationsToDataGrid, setBillCorrectionApplicationsToDataGrid] = useState([]);
  const [billCorrectionApplicationsOverDue, setBillCorrectionApplicationsOverDue] = useState([]);
  const [billCorrectionApplicationsOverDueToDataGrid, setBillCorrectionApplicationsOverDueToDataGrid] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [eFileData, setEFileData] = useState([]);
  const { state } = useLocation();
  const { foundId } = state ? state : '';
  const [foundInNc, setFoundInNc] = useState();

  const [ripeAge, setRipeAge] = useState(0);
  const [unripeAge, setUnripeAge] = useState(0);
  const [error, setError] = useState('')


  const tableColumnsProcessingSummary = [
    {
      header: 'Step',
      accessorKey: 'stepName',
    },
    {
      header: 'Processed By',
      accessorKey: 'processedBy',
    },
    {
      header: 'Date',
      accessorKey: 'date',
    },

    {
      header: 'Remarks',
      accessorKey: 'remarks',
    },
  ]

  const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
  ])

  // Sub Popup states
  const [applicationSubittedPopUp, setApplicationSubmittedPopUp] = useState(false);

  //#endregion

  //#region constants / variables 
  const navigate = useNavigate();

  let BCStatusBarArray = [
    {
      title1: 'APPLICATION',
      title2: 'SUBMISSION',
    },
    {
      title1: 'APPLICATION',
      title2: 'APPROVAL',
    },
  ]

  const tblColumns = [
    { field: "applicationId", type: 'text', sortable: false, filterable: false, headerName: 'Application No.', align: 'center', headerStyle: { ...tableStyle.headerStyle, width: '3000px' }, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    { field: "creationDate", type: 'date', sortable: false, filterable: true, headerName: 'Date', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    { field: "applicantName", headerName: 'Applicant Name', sortable: false, filterable: false, type: 'text', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    { field: "sanctionedLoad", headerName: 'Load (kW)', sortable: false, filterable: false, align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    { field: "tariff", type: 'text', sortable: false, filterable: false, headerName: 'Tariff', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: '12px' } },
    { field: "applicationProgressId", type: 'singleSelect', sortable: false, filterable: true, valueOptions: ['Documents Uploading', 'Documents Verification', 'Arrear Verification', 'Field Survey', 'Reference No. Allocation', 'Demand Note Payment', 'DN Payment Verification', 'RCO Creation', 'Meter Installation', 'Ready for Billing'], headerName: 'Description', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: '12px' } },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: '15px' },
      field: 'downloads',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <ActionsCell data={params} />
        )
      }
    }
  ]

  const tblColumnsOverDue = [
    { field: "applicationId", type: 'text', sortable: false, filterable: false, headerName: 'Application No.', align: 'center', headerStyle: { ...tableStyleOverDue.headerStyle, width: '3000px' }, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: { ...tableStyleOverDue.rowCellStyle, marginLeft: '5px' } },
    { field: "creationDate", type: 'date', headerName: 'Date', sortable: false, filterable: true, align: 'center', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
    { field: "applicantName", headerName: 'Applicant Name', sortable: false, filterable: false, type: 'text', align: 'left', disableColumnMenu: true, sortable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
    { field: "sanctionedLoad", headerName: 'Load (kW)', sortable: false, filterable: false, align: 'center', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
    { field: "tariff", type: 'text', sortable: false, filterable: false, headerName: 'Tariff', align: 'left', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: '12px' } },
    { field: "applicationProgressId", type: 'singleSelect', sortable: false, filterable: true, valueOptions: ['Documents Uploading', 'Documents Verification', 'Arrear Verification', 'Field Survey', 'Ref. No. Allocation', 'Demand Note Payment', 'DN Payment Verification', 'RCO Creation', 'Meter Installation', 'Ready for Billing'], headerName: 'Description', align: 'left', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: '12px' } },
    { field: "exceededDuration", type: 'text', sortable: false, filterable: false, headerName: 'Days', align: 'center', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: { ...tableStyleOverDue.rowCellStyle, color: 'red', minWidth: '20px' } },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: '15px' },
      field: 'downloads',
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <ActionsCell data={params} />
        )
      }
    }
  ]

  //#endregion

  //#region api function

  const callTariffList = async () => {

    const myHeaders = new Headers()
    myHeaders.append('Authorization', token)

    var requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: myHeaders
    };

    await fetch(cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail", requestOptions)
      .then(response => response.json())
      .then(result => {
        setAllTariffList(result.data)
      })
      .catch(() => {});
  }

  //#endregion

  //#region functions

  useScanDetection({
    onComplete: async (code) => {
      if (code) {
        code = code.replace(/Shift/g, '');
        const regex = /^[A-Z]{2}-\d{14,15}$/;
        if (regex.test(code)) {
          await handleRowClick(code);
        } else {
        }
      }
    },
    minLength: 4, // EAN13
  });

  const handleClose = async () => {
    //field verification fields 
    setError('')
    setOpen(false);
    setEFileData([]);
    setTableDataProcessingSummary([])
    dispatch(fetchPaginatedBillCorrectionNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, loadFrom: loadFromNormal, loadTo: loadToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
    dispatch(fetchPaginatedBillCorrectionOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, loadFrom: loadFromOverdue, loadTo: loadToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
  };

  const filterRCApp = async (applicationId) => {
    const myArray = billCorrectionApplications
    let allApplications = myArray.concat(billCorrectionApplicationsOverDue)
    let itemFound = allApplications.find(item => item.applicationId === applicationId)
    if (itemFound === undefined) {
      itemFound = await SearchIndividualApplication(token, applicationId, '13')
    }

    return itemFound;
  }

  const apiToDataGridConversionNormal = async () => {
    try {
      setViewBackdrop(true)
      const tempArray = []
      if (billCorrectionApplications) {
        billCorrectionApplications.forEach((item) => {
          let dataGridObject = {}
          if (item.applicationId && item.applicationId.startsWith('BC')) {
            if (!item.objectionStatus || item.objectionStatus == 0 || item.objectionStatus == 2) {
              dataGridObject = {
                "applicationId": item.applicationId,
                "applicationType": item.applicationType,
                "creationDate": convertDateDDMMYY(item.creationDate),
                "lastModificationDate": convertDate(item.lastModificationDate),
                "connectionType": item.connectionType,
                "applicantName": item.consumerName,
                "applicantCNIC": item.consumerCNIC,
                "sanctionedLoad": item.sanctionedLoad,
                "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                "applicationProgressId": progFunc(item.applicationProgressId),
                "applicationProgressNumber": item.applicationProgressId,
                "inTime": item.inTime,
                "tariff": allTariffList && getTariff(item.tariffCode, allTariffList),
                "exceededDuration": item.exceededDuration,
                "releventApplicationFlage": item.releventApplicationFlage,
                "downloadBill": async () => {
                  let application = await filterRCApp(item.applicationId)
                  await downloadBill(application.referenceNo)
                },
              }
            }
            else if (item.objectionStatus === 1) {
              dataGridObject = {
                "applicationId": item.applicationId,
                "applicationType": item.applicationType,
                "creationDate": convertDateDDMMYY(item.creationDate),
                "lastModificationDate": convertDate(item.lastModificationDate),
                "connectionType": item.connectionType,
                "applicantName": item.consumerName,
                "applicantCNIC": item.consumerCNIC,
                "sanctionedLoad": item.sanctionedLoad,
                "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                "applicationProgressNumber": item.applicationProgressId,
                "inTime": item.inTime,
                // "tariff": allTariffList && getTariff(item.tariffCode, allTariffList),
                "exceededDuration": item.exceededDuration,
                "releventApplicationFlage": item.releventApplicationFlage,
                "applicationProgressId": item.remarks,
                "downloadBill": async () => {
                  let application = await filterRCApp(item.applicationId)
                  await downloadBill(application.referenceNo)
                },
              }
            }
            tempArray.push(dataGridObject)
          }
        })
      }
      else {
        const dataGridObject = {
          "applicationId": ' ',
          "connectionType": '',
          "applicantName": ' ',
          "applicantCNIC": ' ',
          "applicationStatusId": statusFunc(' '),
        }
        tempArray.push(dataGridObject)
      }

      setBillCorrectionApplicationsToDataGrid(tempArray);
      setViewBackdrop(false)
    }
    catch (e) {
    }
  }

  const apiToDataGridConversionOverdue = async () => {
    try {
      setViewBackdrop(true)

      const tempArray = []
      if (billCorrectionApplicationsOverDue) {
        billCorrectionApplicationsOverDue.forEach((item) => {
          let dataGridObject = {}
          if (item.applicationId && item.applicationId.startsWith('BC')) {
            if (!item.objectionStatus || item.objectionStatus == 0 || item.objectionStatus == 2) {
              dataGridObject = {
                "applicationId": item.applicationId,
                "applicationType": item.applicationType,
                "creationDate": convertDateDDMMYY(item.creationDate),
                "lastModificationDate": convertDate(item.lastModificationDate),
                "connectionType": item.connectionType,
                "applicantName": item.consumerName,
                "applicantCNIC": item.consumerCNIC,
                "sanctionedLoad": item.sanctionedLoad,
                "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                "applicationProgressId": progFunc(item.applicationProgressId),
                "applicationProgressNumber": item.applicationProgressId,
                "inTime": item.inTime,
                "tariff": allTariffList && getTariff(item.tariffCode, allTariffList),
                "exceededDuration": item.exceededDuration,
                "releventApplicationFlage": item.releventApplicationFlage,
                "downloadBill": async () => {
                  let application = await filterRCApp(item.applicationId)
                  await downloadBill(application.referenceNo)
                },
              }
            }
            else if (item.objectionStatus === 1) {
              dataGridObject = {
                "applicationId": item.applicationId,
                "applicationType": item.applicationType,
                "creationDate": convertDateDDMMYY(item.creationDate),
                "lastModificationDate": convertDate(item.lastModificationDate),
                "connectionType": item.connectionType,
                "applicantName": item.consumerName,
                "applicantCNIC": item.consumerCNIC,
                "sanctionedLoad": item.sanctionedLoad,
                "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                "applicationProgressNumber": item.applicationProgressId,
                "inTime": item.inTime,
                // "tariff": allTariffList && getTariff(item.tariffCode, allTariffList),
                "exceededDuration": item.exceededDuration,
                "releventApplicationFlage": item.releventApplicationFlage,
                "applicationProgressId": item.remarks,
                "downloadBill": async () => {
                  let application = await filterRCApp(item.applicationId)
                  await downloadBill(application.referenceNo)
                }
              }
            }
            tempArray.push(dataGridObject)
          }
        })
      }
      else {
        const dataGridObject = {
          "applicationId": ' ',
          "connectionType": '',
          "applicantName": ' ',
          "applicantCNIC": ' ',
          "applicationStatusId": statusFunc(' '),
        }
        tempArray.push(dataGridObject)
      }

      setBillCorrectionApplicationsOverDueToDataGrid(tempArray);
      setViewBackdrop(false)
    }
    catch (e) {
    }
  }

  const statusFunc = (x, objection) => {
    if (objection === 0 || objection === 2) {
      if (x === 0) {
        return 'Pending'
      }
      else if (x > 0 && x < 5) {
        return 'In Process'
      }
      else if (x >= 5 && x < 10) {
        return 'Approved'
      }
      else {
        return 'Completed'
      }
    }
    else {
      return 'Objection'
    }
  }

  const progFunc = (x) => {
    if (x === 0) {
      return 'Documents Uploading'
    }
    else if (x === 1) {
      return 'Documents Verification'
    }
    else if (x === 2) {
      return 'Arrear Verification'
    }
    else if (x === 3) {
      return 'Refer to Field Survey'
    }
    else if (x === 4) {
      return 'Field Survey'
    }
    else if (x === 5) {
      return 'Demand Note Issuance'
    }
    else if (x === 6) {
      return 'Demand Note Payment'
    }
    else if (x === 7) {
      return 'DN Payment Verification'
    }
    else if (x === 8) {
      return 'RCO Fee & Bill Submission'
    }
    else if (x === 9) {
      return 'RCO Fee Verification'
    }
    else if (x === 10) {
      return 'Meter Installation'
    }
    else if (x === 11) {
      return 'Ready for Billing'
    }
    else if (x === 12) {
      return 'Completed'
    }
  };

  const handleRowClick = async (applicationId, event) => {
    setViewBackdrop(true);
    let demandNoticeDetails = '';
    let dnPayDate = ''
    let rcoDets = ''
    if (applicationId) {
      const item = await filterRCApp(applicationId);
      if (item) {
        setDialogRowData(item);
        // await callEfileAPI(applicationId, item);

        setViewBackdrop(false);
        setOpen(true);
      }
    }
  };

  const eFileIcon = () => {
    return (
      <img src={eFileIcon} alt="Efile Icon" height="20" width="25" />
    )
  }

  const openDetailsPopUp = async (stepName) => {

  }

  const getTariff = (tariffCode, tariffs) => {
    if (tariffs) {
      let tariff = tariffs.find((item) => item.tariffCode == tariffCode)
      return tariff.tariffName
    } else {
      return 'Tariff Name'
    }
  }

  const errorCloses = () => {
    setError('')
  };

  //#endregion

  //#region formiks

  //#endregion

  //#region useEffects

  useEffect(() => {
    callTariffList()
  }, [])

  useEffect(() => {
    if (billCorrectionApplications && allTariffList) {
      apiToDataGridConversionNormal();
    }
  }, [allTariffList, billCorrectionApplications]);

  useEffect(() => {
    if (billCorrectionApplicationsOverDue && allTariffList) {
      apiToDataGridConversionOverdue()
    }
  }, [allTariffList, billCorrectionApplicationsOverDue]);

  useEffect(() => {
    if (foundId && foundId !== '') {
      setFoundInNc(foundId)
    }
  }, [foundId])

  useLayoutEffect(() => {
    if (foundInNc) {
      handleRowClick(foundInNc)
    }
  }, [foundInNc])
  //#endregion

  useImperativeHandle(ref, () => ({
    handleRowClick
  }));

  const location = useLocation()
  const currentPath = location.pathname;

  return (
    <>
      {/* Applications Table */}
      {
        (props.showTable && currentPath == "/bill-correction-table") &&
        <Box className='form-box'>
          <div style={{ display: 'flex', flexDirection: "row" }}>
            <Box className='application-table' style={{ marginRight: '10px' }}>
              <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Bill Correction  ( {numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )</h3>
              <div className='div-datagrid' >
                <BasicTable
                  columns={tblColumns}
                  data={billCorrectionApplicationsToDataGrid}
                  handleRowClick={(params) => handleRowClick(params.applicationId)}
                  sx={tableStyle}
                  rowHeight={37}
                  pageSize={20}
                  totalPages={totalPagesNormal}
                  totalRecords={totalRecordsNormal}
                  currentPage={currentPageNormal}
                  handleFilterDateFrom={handleDateFromFilterNormal}
                  handleFilterDateTo={handleDateToFilterNormal}
                  resetDateFilter={handleResetDateFilterNormal}
                  handleFilterProgressId={handleProgressIdFilterNormal}
                  handleFilterObjectionStatus={handleObjectionStatusFilterNormal}
                  resetProgressIdFilter={handleResetProgressIdFilterNormal}
                  resetObjectionStatusFilter={handleResetObjectionStatusFilterNormal}
                  firstPage={handleFirstPageNormal}
                  nextPage={handleNextPageNormal}
                  previousPage={handlePreviousPageNormal}
                  lastPage={handleLastPageNormal}
                  rowsPerPageOptions={[18, 30, 60]}
                  rowsPageOption={false}
                  getRowStyle={(params) => {
                    return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                  }}
                />
              </div>
            </Box>
            <Box className='application-table' >
              <div style={{ display: 'flex', alignItems: 'end' }}>
                <h3 style={{ color: '#9d192f', marginBottom: '10px' }}><img src={warning} alt='icon' style={{ width: '1vw', marginRight: '5px' }} />Over Due Applications  ( {numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"} )</h3>
              </div>
              <div className='div-datagrid' >
                <BasicTable
                  columns={tblColumnsOverDue}
                  data={billCorrectionApplicationsOverDueToDataGrid}
                  handleRowClick={(params) => handleRowClick(params.applicationId)}
                  sx={tableStyleOverDue}
                  rowHeight={37.5}
                  pageSize={20}
                  firstPage={handleFirstPageOverdue}
                  nextPage={handleNextPageOverdue}
                  previousPage={handlePreviousPageOverdue}
                  lastPage={handleLastPageOverdue}
                  handleFilterDateFrom={handleDateFromFilterOverdue}
                  handleFilterDateTo={handleDateToFilterOverdue}
                  resetDateFilter={handleResetDateFilterOverdue}
                  resetProgressIdFilter={handleResetProgressIdFilterOverdue}
                  resetObjectionStatusFilter={handleResetObjectionStatusFilterOverdue}
                  handleFilterProgressId={handleProgressIdFilterOverdue}
                  handleFilterObjectionStatus={handleObjectionStatusFilterOverdue}
                  totalPages={totalPagesOverdue}
                  totalRecords={totalRecordsOverdue}
                  currentPage={currentPageOverdue}
                  rowsPerPageOptions={[18, 30, 60]}
                  rowsPageOption={false}
                  getRowStyle={(params) => {
                    return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyleOverDue.evenRow : tableStyleOverDue.oddRow
                  }}
                />
              </div>
            </Box>
          </div>
        </Box>
      }

      {/* Main Popup */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={'false'}
        className='main-dialog'
      >
        <DialogTitle className='dialog-title'>
          <Grid container spacing={1} className='headercontainer'>
            <Grid item lg={0.5}></Grid>
            <Grid item lg={11} className='applicationTitleGrid'>
              <Typography className="applicationTitleText">Bill Correction -
                <span style={{ marginLeft: '1%', color: 'white' }}>
                  {dialogRowData.applicationProgressId === 0 && ' Document Uploading'}
                  {dialogRowData.applicationProgressId === 1 && ' Document Verification'}
                  {dialogRowData.applicationProgressId === 2 && ' Arrear Verification'}
                  {dialogRowData.applicationProgressId === 3 && ' Refer To Field Verification'}
                  {dialogRowData.applicationProgressId === 4 && ' Field Survey'}
                  {dialogRowData.applicationProgressId === 5 && ' Demand Note Issuance'}
                  {dialogRowData.applicationProgressId === 6 && ' DN Payment Submission'}
                  {dialogRowData.applicationProgressId === 7 && ' DN Payment Verification'}
                  {dialogRowData.applicationProgressId === 8 && ' RCO Fee & Bill Submission'}
                  {dialogRowData.applicationProgressId === 9 && ' RCO Fee Verification'}
                  {dialogRowData.applicationProgressId === 10 && ' Meter Installation'}
                  {dialogRowData.applicationProgressId === 11 && ' Ready for Billing'}
                  {dialogRowData.applicationProgressId === 12 && ' Completed'}
                </span>
              </Typography>
            </Grid>
            <Grid item lg={0.5} className="closeIcon" >
              <CloseIcon id="clearPopup" onClick={handleClose} sx={{ color: 'white' }} />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: 'white' }} >
          <DialogContentText className="dialog-content">
            <Grid container spacing={1} className='headercontainer'>
              <Grid item lg={12} className='status-bar'>
                <StepProgressBar array={BCStatusBarArray} applicationProgressId={dialogRowData.applicationProgressId} objection={dialogRowData.objectionStatus} openDetailsPopUp={openDetailsPopUp} pageName='Bill Correction' />
              </Grid>
              <Grid item lg={12} className='application-details'>
                <Grid container spacing={1} className="first-row">
                  <Grid item lg={1.33} className='first-row-item'>
                    <p className='prop-title'>Application Id</p><p className='prop-detail'>{dialogRowData.applicationId ? dialogRowData.applicationId : '-'}</p>
                  </Grid>
                  <Grid item lg={2.66} className='first-row-item'>
                    <p className='prop-title'>Applicant Name</p><p className='prop-detail'>{dialogRowData.consumerName ? dialogRowData.consumerName : '-'}</p>
                  </Grid>
                  <Grid item lg={1.33} className='first-row-item'>
                    <p className='prop-title'>Applicant CNIC</p><p className='prop-detail'>{dialogRowData.consumerCNIC ? dialogRowData.consumerCNIC : '-'}</p>
                  </Grid>
                  <Grid item lg={1.33} className='first-row-item'>
                    <p className='prop-title'>{dialogRowData.applicantRelativeType ? dialogRowData.applicantRelativeType : `Father's Name`}</p><p className='prop-detail'>{dialogRowData.applicantRelativeName ? dialogRowData.applicantRelativeName : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'>Sanct. Load(kW)</p><p className='prop-detail'>{dialogRowData.sanctionedLoad ? dialogRowData.sanctionedLoad : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'>Connection Type</p><p className='prop-detail'>{dialogRowData.connectionCategory ? dialogRowData.connectionCategory : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'>Meter Type</p><p className='prop-detail'>{dialogRowData.meterType ? dialogRowData.meterType : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'>Tariff</p><p className='prop-detail'>{dialogRowData.tariffCode ? dialogRowData.tariffCode : '-'}</p>
                  </Grid>
                  <Grid item lg={1.33} className='first-row-item' >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <p className='prop-title'>Unripe Age (Days)</p>
                      {/* {
                        (dialogRowData.applicationProgressId <= 1 && CheckPermissions(permissions, 'General Services', 'BillCorrection', 'Basic Permissions', 'Update')) &&
                        <img src={pencilIcon} alt="edit" width={17.5} height={17.5} style={{ position: 'relative', cursor: 'pointer', marginRight: '-22.5px' }} onClick={handleEditIconClick} />
                      } */}
                    </div>
                    <p className='prop-detail'>{dialogRowData.applicationProgressId >= 1 ? unripeAge : "-"}</p>
                  </Grid>
                </Grid>
                <Grid container spacing={1} className='second-row'>
                  <Grid item lg={1.33} className="second-row-item">
                    <p className='prop-title'>Subdivision</p><p className='prop-detail'>{subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
                  </Grid>
                  <Grid item lg={1.33} className="second-row-item" >
                    <p className='prop-title' >Ref. No.</p><p className='prop-detail'>{dialogRowData.referenceNo ? dialogRowData.referenceNo : '-'}</p>
                  </Grid>
                  <Grid item lg={0.665} className="second-row-item" >
                    <p className='prop-title' >Status</p><p className='prop-detail'>{dialogRowData.applicantStatus ? dialogRowData.applicantStatus : 'Owner'}</p>
                  </Grid>
                  <Grid item lg={1.33} className="second-row-item" >
                    <p className='prop-title' >Phone No.</p><p className='prop-detail'>{dialogRowData.applicantMobileNo ? dialogRowData.applicantMobileNo : '-'}</p>
                  </Grid>
                  {(dialogRowData.connectionCategory == "Domestic" || dialogRowData.connectionCategory == "Temporary" || dialogRowData.connectionCategory == "Public Lightning" || dialogRowData.connectionCategory == "Railway Tracking") ?
                    <>
                      <Grid item lg={3.99} className="second-row-item">
                        <p className='prop-title'>Address</p><p className='prop-detail'>{dialogRowData.consumerAddress ? dialogRowData.consumerAddress : '-'}</p>
                      </Grid>
                      <Grid item lg={1.33} className="second-row-item">
                        <p className='prop-title'>Exceeded (Days)</p><p className='prop-detail'>{dialogRowData.exceededDuration ? dialogRowData.exceededDuration : "-"}</p>
                      </Grid>
                      <Grid item lg={1.33} className="second-row-item">
                        <p className='prop-title'>Ripe Age (Days)</p><p className='prop-detail'>{dialogRowData.applicationProgressId >= 5 ? ripeAge : "-"}</p>
                      </Grid>
                    </> :
                    <>
                      <Grid item lg={2.66} className="second-row-item">
                        <p className='prop-title'>Address</p><p className='prop-detail'>{dialogRowData.consumerAddress ? dialogRowData.consumerAddress : '-'}</p>
                      </Grid>
                      <Grid item lg={1} className="second-row-item">
                        <p className='prop-title'>NTN.</p><p className='prop-detail'>{dialogRowData.NTN ? dialogRowData.NTN : '-'}</p>
                      </Grid>
                      <Grid item lg={1} className="second-row-item">
                        <p className='prop-title'>STRN.</p><p className='prop-detail'>{dialogRowData.STRN ? dialogRowData.STRN : '-'}</p>
                      </Grid>
                      <Grid item lg={1} className="second-row-item">
                        <p className='prop-title'>Exceeded (Days)</p><p className='prop-detail'>{dialogRowData.exceededDuration ? dialogRowData.exceededDuration : "-"}</p>
                      </Grid>
                      <Grid item lg={1} className="second-row-item">
                        <p className='prop-title'>Ripe Age (Days)</p><p className='prop-detail'>{dialogRowData.applicationProgressId >= 5 ? ripeAge : "-"}</p>
                      </Grid>
                    </>
                  }
                </Grid>
              </Grid>
              <Grid item className='processing-summary'>
                <h2 className='title'>Activity Log</h2>
                {
                  eFileData && <ProcessingSummaryTable data={tableDataProcessingSummary} columns={tableColumnsProcessingSummary} openDetailsPopUp={openDetailsPopUp} />
                }
              </Grid>
              <Grid item className="action-form">
                <div className='fields'>
                  {
                    dialogRowData.applicationProgressId === 1 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                      CheckPermissions(permissions, 'General Services', 'Reconnection', 'Workflow Permisions', 'Document Verification') ?
                        <>
                          <h3 className='step-title'>Application Approval</h3>
                          <Grid className='document-verification-container' container spacing={1} sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '1%', padding: '2%' }} >
                            {
                              error &&
                              <Error
                                error={error}
                                onClose={errorCloses}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                              />
                            }

                          </Grid>
                        </> :
                        <>
                          <h3 className='step-title'>Documents Verification</h3>
                          <div className='description-box'>
                            <p className='group-description'><InfoIcon className='icon' /> Document verification is in process by the Customer Service Lead.</p>
                          </div>
                        </> :
                      dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 1 ?
                        <>
                          <h3 className='step-title'>Documents Objection</h3>

                        </> :
                        dialogRowData.applicationProgressId === 2 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                          <>
                            <h3 className='step-title'>Arrear Verification</h3>
                            {
                              CheckPermissions(permissions, 'General Services', 'Reconnection', 'Workflow Permisions', 'Arrears Verification') ?
                                <>
                                  <Grid container className='field-survey-container'>
                                    <Grid item lg={12}>
                                      <Grid container spacing={2}>

                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </> :
                                <div className='description-box'>
                                  <p className='group-description'><InfoIcon className='icon' />Arrears Verification is in process by the LS DR of subdivision: {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}. </p>
                                </div>
                            }
                          </> :
                          dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 1 ?
                            <>
                              <h3 className='step-title'>Arrears Objection</h3>
                              <>
                                <Grid item lg={12}>


                                  <Grid item lg={12} sx={{ marginTop: '2%', alignItems: 'center', marginLeft: '8%' }}>
                                    <img src={dialogRowData.applicantCNICFront} alt="Cnic Front" style={{ width: '40%', height: '40%' }} ></img>
                                    <img src={dialogRowData.applicantCNICBack} alt="Cnic Back" style={{ width: '40%', height: '40%', marginLeft: '2%' }} ></img>




                                  </Grid>

                                </Grid>
                              </>
                            </> :
                            null
                  }
                </div>
                <div className='actions'>
                  {
                    dialogRowData.applicationProgressId === 0 ?
                      <>
                        {
                          CheckPermissions(permissions, 'General Services', 'Reconnection', 'Basic Permissions', 'Update') ?
                            <button onClick={() => navigate('/new-connection-update', { state: { dialogRowData } })} className='view-button' >Upload Pending Documents</button>
                            : null
                        }
                      </> :
                      dialogRowData.applicationProgressId === 1 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                        CheckPermissions(permissions, 'General Services', 'Reconnection', 'Workflow Permisions', 'Document Verification') &&
                        <>
                          {
                            (
                              dialogRowData.paidBillImageFlag !== 1 || dialogRowData.applicantCNICFrontFlag !== 1 || dialogRowData.applicantCNICBackFlag !== 1
                            )
                              ?
                              <>

                              </>
                              :
                              null
                          }
                        </> :
                        dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 1 ?
                          <>
                            {
                              CheckPermissions(permissions, 'General Services', 'Reconnection', 'Basic Permissions', 'Update') ?
                                <>
                                  <button onClick={() => navigate('/reconnection-update', { state: { dialogRowData } })} className='view-button'>Re-Upload Document</button>
                                </> :
                                <>
                                </>
                            }
                          </> : null
                  }
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >

      < Dialog
        open={applicationSubittedPopUp}
        onClose={() => { setApplicationSubmittedPopUp(false) }}
        fullWidth={true}
        maxWidth={'md'}
        className='subpopup-dialog1' >
        <DialogTitle className='dialog-title'>
          <p className='title'>
            Application Submitted
          </p>
          <CloseIcon id="clearPopup" className='closeIcon' onClick={() => { setApplicationSubmittedPopUp(false) }} />
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <Grid container gap={1} className='container' >
            <Grid item lg={12} className='application-details'>
              <Grid item lg={3} className='first-row-item' >
                <p className='prop-title'>Application Id</p>
                <p className=' prop-detail'>{dialogRowData.applicationId}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applicant Name</p>
                <p className=' prop-detail'>{dialogRowData.consumerName}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applicant CNIC.</p>
                <p className=' prop-detail'>{dialogRowData.consumerCNIC}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>{dialogRowData.applicantRelationType ? sodowo(dialogRowData.applicantRelationType) : '-'}</p>
                <p className=' prop-detail'>{dialogRowData.applicantRelativeName ? dialogRowData.applicantRelativeName : "-"}</p>
              </Grid>
            </Grid>
            <Grid item lg={12} className='application-details1'>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applied Date</p>
                <p className=' prop-detail'>{convertDate(dialogRowData.creationDate)}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Subdivision</p>
                <p className=' prop-detail'>{subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applied Load</p>
                <p className=' prop-detail'>{dialogRowData.sanctionedLoad}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Connection Type</p>
                <p className=' prop-detail'>{dialogRowData.connectionCategory}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Sub. Through</p>
                <p className=' prop-detail'>{dialogRowData.submittedThrough}</p>
              </Grid>
            </Grid>
            <Grid item lg={12} className='application-details'>
              <Grid item lg={7} className='first-row-item' >
                <p className='prop-title'>Applicant Address</p>
                <p className=' prop-detail'>{dialogRowData.premisesAddress}</p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='dialog-action'>
          <p className='description'>Application Submitted by: {dialogRowData.consumerName} on: {convertDatewithTime(dialogRowData.creationDate)}</p>
        </DialogActions>
      </Dialog >
    </>
  )
})

export default BillCorrectionTable;